'use strict';
const HIGHLIGHT_CLASS_NAME = 'unibox__selectable--active';
const HIGHLIGHT_ID = 'unibox-active';
export default {
    removeHighlight(node) {
        node.removeClass(HIGHLIGHT_CLASS_NAME);
        node.removeAttribute('id');
        node.attr('aria-selected', 'false');
    },
    addHighlight(node) {
        node.addClass(HIGHLIGHT_CLASS_NAME);
        node.attr('id', HIGHLIGHT_ID);
        node.attr('aria-selected', 'true');
    },
    HIGHLIGHT_ID
};
